import React from 'react'

const Footer = () => {
    return (
        <footer className="mt-auto bg-dark">
            <div className="text-center py-3">
                <span className="text-white">©2018 Copyright:</span> <a href="/">BudgetManager.com</a>
                <br />
            </div>
        </footer>
    )
}

export default Footer
